import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import { Toolbar } from '../Toolbar/Toolbar.js';
import { Typography } from '../Typography/Typography.js';
var styles = {
  dialogContentText: {
    padding: 1
  }
}; // @deprecated

var createToolbar = function createToolbar(items) {
  var toolbar = [{
    id: 1,
    position: 'right',
    items: items
  }];
  return /*#__PURE__*/React.createElement(Toolbar, {
    items: toolbar
  });
};

var createContent = function createContent(contentItems) {
  return contentItems.map(function (item) {
    return item;
  });
}; // @deprecated


var _DeprecatedModal = function _DeprecatedModal(_ref) {
  var contentItems = _ref.contentItems,
      title = _ref.title,
      open = _ref.open,
      helperText = _ref.helperText,
      toolbarItems = _ref.toolbarItems,
      onClose = _ref.onClose,
      fullWidth = _ref.fullWidth,
      maxWidth = _ref.maxWidth;
  var dialogContentText = styles.dialogContentText;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dialog, {
    open: open,
    "aria-labelledby": "form-dialog-title",
    onClose: onClose // disableBackdropClick={disableBackdropClick}
    ,
    fullWidth: fullWidth,
    maxWidth: maxWidth
  }, title && /*#__PURE__*/React.createElement(DialogTitle, {
    id: "form-dialog-title"
  }, title), /*#__PURE__*/React.createElement(DialogContent, {
    "aria-labelledby": "form-dialog-text"
  }, contentItems && contentItems.length > 0 && createContent(contentItems)), /*#__PURE__*/React.createElement(DialogActions, null, toolbarItems && toolbarItems.length > 0 && createToolbar(toolbarItems)), helperText && /*#__PURE__*/React.createElement(DialogContentText, {
    id: "form-dialog-text",
    sx: dialogContentText
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, helperText))));
};

_DeprecatedModal.displayName = 'Modal';
export { _DeprecatedModal };